import { useState } from "react";
import axios from "axios";

/*
  Reenviar los mails fallidos de un Informe General (p. ej. rechazados por el límite por hora del proveedor).
  - GET  /reportes/informes-generales/<id>/fallidos/          → { total, por_limite, items }
  - POST /reportes/informes-generales/<id>/reenviar-fallidos/ → 202 { job_id, total } (mismo seguimiento que el
    envío masivo). Sale con el mismo PDF, respeta el tope por hora y no toca el período.
*/
export const urlFallidos = (informeId) => `/reportes/informes-generales/${informeId}/fallidos/`;
export const urlReenviarFallidos = (informeId) => `/reportes/informes-generales/${informeId}/reenviar-fallidos/`;

// Cantidad de mails para reenviar (0 si no hay o si falla la consulta: el botón no se muestra).
export const contarFallidos = async (informeId, token) => {
  try {
    const { data } = await axios.get(urlFallidos(informeId), { headers: { Authorization: `Bearer ${token}` } });
    return Number(data?.total) || 0;
  } catch {
    return 0;
  }
};

const useReenviarFallidos = ({ token, toast, envioJob }) => {
  const [reenviando, setReenviando] = useState(false);

  // Devuelve true si el reenvío quedó en marcha.
  const reenviarFallidos = async (informeId, { confirmarReenvio = false } = {}) => {
    if (!informeId) return false;
    setReenviando(true);
    try {
      const res = await axios.post(
        urlReenviarFallidos(informeId),
        confirmarReenvio ? { confirmar_reenvio: true } : {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const jobId = res.data?.job_id;
      if (res.status !== 202 || !jobId) throw new Error(res.data?.detail || "No se pudo iniciar el reenvío.");
      envioJob?.startJob?.(jobId, {
        informe_id: informeId,
        modo_envio: "mail",
        destinatarios: res.data?.total || 0,
        reenvio: true,
      });
      return true;
    } catch (error) {
      const data = error?.response?.data;
      if (error?.response?.status === 409 && data?.code === "reenvio_con_diferencias" && !confirmarReenvio) {
        setReenviando(false);
        if (window.confirm(data.detail || data.error)) {
          return reenviarFallidos(informeId, { confirmarReenvio: true });
        }
        return false;
      }
      toast({
        status: data?.code === "sin_fallidos" ? "info" : "error",
        title: data?.code === "sin_fallidos" ? undefined : "No se pudo reenviar.",
        description: data?.detail || data?.error || error.message,
      });
      return false;
    } finally {
      setReenviando(false);
    }
  };

  return { reenviando, reenviarFallidos };
};

export default useReenviarFallidos;
